export default __webpack_public_path__ + "static/media/Cloudxier-NICOLAS-Profile-Developer.492ca9cc.png";